import { IconTooltip } from '@giphy/react-giphy-brand'
import isEmail from 'validator/lib/isEmail'
import { Fragment, PureComponent } from 'react'
import { FormInput } from '../form-components'

class LoginFields extends PureComponent {
    state = { isEmailOkay: false, isPasswordOkay: false }
    componentDidUpdate(prevProps, prevState) {
        const { isEmailOkay, isPasswordOkay } = this.state
        const isValid = isEmailOkay && isPasswordOkay
        if (isValid !== prevState.isValid) {
            const { onValidChange } = this.props
            this.setState({ isValid })
            onValidChange(isValid)
        }
    }
    validateEmail = () => {
        const { isEmailOkay, hasEmail } = this.state
        this.setState({
            emailError: isEmailOkay || !hasEmail ? '' : 'Invalid Email.',
        })
    }
    validatePassword = () => {
        const { isPasswordOkay, hasPassword } = this.state
        this.setState({
            passwordError: isPasswordOkay || !hasPassword ? '' : 'Passwords must be at least 6 characters.',
        })
    }
    onEmailChange = val => {
        IconTooltip.hideToolTips()
        this.setState({
            isEmailOkay: isEmail(val),
            hasEmail: !!val,
        })
    }
    onPasswordChange = val => {
        IconTooltip.hideToolTips()
        // only restriction for passwords is that they're 6 chars
        this.setState({
            hasPassword: !!val,
            isPasswordOkay: val && val.length >= 6,
        })
    }
    render() {
        const { emailError, passwordError } = this.state
        return (
            <Fragment>
                <FormInput
                    errorMessage={emailError}
                    errorTooltip
                    onAutoFill={() => {
                        this.setState({
                            isEmailOkay: true,
                        })
                    }}
                    inputProps={{
                        onChange: e => this.onEmailChange(e.target.value),
                        onBlur: this.validateEmail,
                        type: 'email',
                        name: 'email',
                        placeholder: 'Email Address',
                        autoComplete: 'off',
                    }}
                />
                <FormInput
                    errorMessage={passwordError}
                    errorTooltip
                    onAutoFill={() => {
                        this.setState({
                            isPasswordOkay: true,
                        })
                    }}
                    inputProps={{
                        onChange: e => this.onPasswordChange(e.target.value),
                        onBlur: this.validatePassword,
                        type: 'password',
                        name: 'password',
                        placeholder: 'Password',
                        autoComplete: 'off',
                    }}
                />
            </Fragment>
        )
    }
}

export default LoginFields
